export const setPopupVisibility = {
  show: 'POPUP/SHOW',
  hide: 'POPUP/HIDE',
}

export const showErrorPopup = (errorCode: string) => (dispatch: any) => {
  return dispatch({
    type: setPopupVisibility.show,
    payload: {
      type: 'errorPopup',
      data: errorCode,
    },
  })
}

export const hideErrorPopup = () => (dispatch: any) => {
  return dispatch({
    type: setPopupVisibility.hide,
    payload: {
      type: 'errorPopup',
    },
  })
}
